import { render, staticRenderFns } from "./ord_report.vue?vue&type=template&id=736439b8&scoped=true&"
import script from "./ord_report.vue?vue&type=script&lang=js&"
export * from "./ord_report.vue?vue&type=script&lang=js&"
import style0 from "./ord_report.vue?vue&type=style&index=0&id=736439b8&scoped=true&lang=less&"
import style1 from "./ord_report.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736439b8",
  null
  
)

export default component.exports